import { storageKey } from "./configs";
import get from "lodash/get";

const localSetItem = (value: Object) => {
  localStorage.setItem(storageKey, JSON.stringify(value));
};

const sessionSetItem = (value: Object) => {
  sessionStorage.setItem(storageKey, JSON.stringify(value));
};

const localGetItem = () => {
  let storageData = localStorage.getItem(storageKey);
  let result = {};
  if (storageData !== null && storageData !== undefined) {
    result = JSON.parse(storageData);
  }
  return result;
};

const sessionGetItem = () => {
  let sessionData = sessionStorage.getItem(storageKey);
  let result = {};
  if (sessionData !== null && sessionData !== undefined) {
    result = JSON.parse(sessionData);
  }
  return result;
};

const localRemoveItem = () => {
  localStorage.removeItem(storageKey);
};

const sessionRemoveItem = () => {
  sessionStorage.removeItem(storageKey);
};

const getToken = () => {
  let token = "";
  let localData = localGetItem();
  let sessionData = sessionGetItem();
  if (get(localData, "access_token", "").length) {
    token = get(localData, "access_token", "");
  }
  if (get(sessionData, "access_token", "").length) {
    token = get(sessionData, "access_token", "");
  }
  return token;
};

export { localSetItem, localGetItem, localRemoveItem, sessionSetItem, sessionGetItem, sessionRemoveItem, getToken };
